(function () {
  angular.module("akitabox.ui.dialogs.inspectionProgram", [
    "akitabox.ui.dialogs.inspectionProgram.create",
    "akitabox.ui.dialogs.inspectionProgram.cancel",
    "akitabox.ui.dialogs.inspectionProgram.reactivate",
  ]);
})();
